export default __webpack_public_path__ + "static/media/partnerAd2.219452f5.png";